import ProfileBeruf from './ProfileBeruf';

export default ProfileBeruf;
